/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      let doingAjax = false;

      function toggleAjaxLoading() {
        const ajaxLoader = $( '.ajax-loader-wrap' );
        ajaxLoader.toggleClass( 'is-ajax' );
      }

      $( document ).on( 'click', '.sync-sf-contact', function( e ) {
        e.preventDefault();

        if ( !doingAjax ) {
          toggleAjaxLoading();
          const formData = $( this ).serialize();

          $.ajax( {
            type: 'GET',
            url: siteInfo.wpApiSettings.ll + 'get/salesforceContact',
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {
              toggleAjaxLoading();
              if ( data.status === 'failure' ) {
                $( '.ajax-loader-wrap' ).toggleClass( 'is-ajax' );
                $( '.sync-sf-contact' ).after( '<p class="mt-5">'+data.message+'</p>' );
              }
            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
              toggleAjaxLoading();
              const responseData = jqXHR.responseJSON;
              if ( responseData.status === 'failure' ) {
                $( '.ajax-loader-wrap' ).removeClass( 'is-ajax' );
                $( '.sync-sf-contact' ).after( '<p class="mt-5">'+data.message+'</p>' );
              } else {
                window.location.reload();
              }
            },
            error: function( request, status, error ) {
              toggleAjaxLoading();
            },
          } );
        }
      } );

      $( document ).on( 'submit', 'form.general-info', function( e ) {
        e.preventDefault();

        const formInputs = $( this ).find( 'input[type="text"], input[type="hidden"]' );
        let allFieldsHaveValues = true;
        formInputs.each( function() {
          if ( $( this ).val() === '' ) {
            allFieldsHaveValues = false;
            return false; // Exit the loop early if any field is empty
          }
        } );

        if ( allFieldsHaveValues && !doingAjax ) {
          toggleAjaxLoading();
          const formData = $( this ).serialize();

          $.ajax( {
            type: 'GET',
            url: siteInfo.wpApiSettings.ll + 'patch/salesforceAccount',
            data: {
              formData: formData,
            },
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {
              //
              toggleAjaxLoading();
            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
              toggleAjaxLoading();
              window.location.reload();
            },
            error: function( request, status, error ) {
              toggleAjaxLoading();
            },
          } );
        } else {
          // Alert or handle the case where some fields are empty
        }
      } );

      $( document ).on( 'submit', 'form.profile-info', function( e ) {
        e.preventDefault();

        if ( !doingAjax ) {
          const formData = $( this ).serialize(); // Serialize form data
          toggleAjaxLoading();
          $.ajax( {
            type: 'GET',
            url: siteInfo.wpApiSettings.ll + 'patch/salesforceContactProfile',
            data: {
              formData: formData,
            },
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {
              // console.log( data );
              toggleAjaxLoading();
            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
              toggleAjaxLoading();
              window.location.reload();
            },
            error: function( request, status, error ) {
              toggleAjaxLoading();
            },
          } );
        }
      } );

      $( document ).on( 'submit', 'form.household-profile-info', function( e ) {
        e.preventDefault();

        if ( !doingAjax ) {
          const formData = $( this ).serialize();
          toggleAjaxLoading();
          $.ajax( {
            type: 'GET',
            url: siteInfo.wpApiSettings.ll + 'patch/salesforceHouseholdContactProfile',
            data: {
              formData: formData,
            },
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {
              // console.log( data );
              // console.log( 'hello' );
              // window.location.reload();
              toggleAjaxLoading();
            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
              toggleAjaxLoading();
              window.location.reload();
            },
            error: function( request, status, error ) {
              toggleAjaxLoading();
            },
          } );
        }
      } );

      $( document ).on( 'submit', 'form.add-household-member', function( e ) {
        e.preventDefault();

        if ( !doingAjax ) {
          const formData = $( this ).serialize();
          toggleAjaxLoading();
          $.ajax( {
            type: 'GET',
            url: siteInfo.wpApiSettings.ll + 'create/salesforceAccountContact',
            data: {
              formData: formData,
            },
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {
              // console.log( data );
              // console.log( 'hello' );
              // window.location.reload();
              toggleAjaxLoading();
            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
              // console.log( 'hello2' );
              toggleAjaxLoading();
              window.location.reload();
            },
            error: function( request, status, error ) {
              toggleAjaxLoading();
            },
          } );
        }
      } );

      $( document ).on( 'submit', 'form.remove-household-member', function( e ) {
        e.preventDefault();

        if ( !doingAjax ) {
          const formData = $( this ).serialize(); // Serialize form data
          toggleAjaxLoading();
          $.ajax( {
            type: 'GET',
            url: siteInfo.wpApiSettings.ll + 'delete/salesforceAccountContact',
            data: {
              formData: formData,
            },
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {
              console.log( data );
              // console.log( 'hello' );
              toggleAjaxLoading();
              // window.location.reload();
            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
              toggleAjaxLoading();
              // console.log( 'hello2' );
              window.location.reload();
            },
            error: function( request, status, error ) {
              toggleAjaxLoading();
            },
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'edit_household', COMPONENT );
} )( app );
